import { createSuspenseQuery, makeQueryKey } from "@steto-care/steto-query";

import { ConditionRepository } from "@/io/repository/ConditionRepository.ts";

export class ConditionQueries {
  constructor(private readonly condition: ConditionRepository = new ConditionRepository()) {}

  /*******************************/
  /*********** QUERIES ***********/
  /*******************************/

  useCondition = createSuspenseQuery(
    "condition",
    patientId => makeQueryKey(patientId),
    async (patientId: string) => this.condition.getCondition(patientId),
  );
}
